export const BASE_URL = "https://pos.mogasoft.com";
// export const BASE_URL = "http://localhost:8000";



// ============================================================================
export const APILogInIfo = BASE_URL + "/api/login-info";

// Dashboard
export const APIDashboardStats = BASE_URL + "/api/dashboard/stats";
export const APIDashboardStock = BASE_URL+"/api/dashboard/low-stock-alerts";
export const APIDashboardSalesTrends = BASE_URL+"/api/dashboard/sales-trends";
export const APIDashboardRecentOrders = BASE_URL+"/api/dashboard/recent-orders";
export const APIDashboardProductDistribution = BASE_URL+"/api/dashboard/product-distribution";
export const APIDashboardPrint = BASE_URL + "/api/dashboard/print";
export const APIDashboardExportExcel = BASE_URL + "/api/dashboard/export-excel";
export const APIDashboardExportPDF = BASE_URL + "/api/dashboard/export-pdf";


// Users
export const APIUserStore = BASE_URL+"/api/user/store";
export const APIUserList = BASE_URL+"/api/user/list";
export const APIUserStats = BASE_URL + "/api/user/stats";
export const APIUserLogin = BASE_URL+"/api/user/login";
export const APIUserLogout = BASE_URL+"/api/user/logout";
export const APIUserUpdate = BASE_URL+"/api/user/update";
export const APIUserDelete = BASE_URL+"/api/user/delete";
export const APIUserUpdatePassword = BASE_URL+"/api/user/update/password";
export const APIUserPrint = BASE_URL + "/api/user/print";
export const APIUserExportExcel = BASE_URL + "/api/user/export-excel";
export const APIUserExportPDF = BASE_URL + "/api/user/export-pdf";

// System Logs
export const APISystemLogsList = BASE_URL + "/api/system-logs/list";
export const APISystemLogsStats = BASE_URL + "/api/system-logs/stats";
export const APISystemLogsShow = BASE_URL + "/api/system-logs/show";
export const APISystemLogsDelete = BASE_URL + "/api/system-logs/delete";
export const APISystemLogsClean = BASE_URL + "/api/system-logs/clean";
export const APISystemLogsExportExcel = BASE_URL + "/api/system-logs/export-excel";
export const APISystemLogsExportPDF = BASE_URL + "/api/system-logs/export-pdf";
export const APISystemLogsFilterOptions = BASE_URL + "/api/system-logs/filter-options";

// Categories
export const APICategoriesList = BASE_URL+"/api/categories/list";
export const APICategoriesNames = BASE_URL+"/api/categories/names";
export const APICategoriesStats = BASE_URL + "/api/categories/stats";
export const APICategoriesStore = BASE_URL+"/api/categories/store";
export const APICategoriesUpdate = BASE_URL+"/api/categories/update";
export const APICategoriesDelete = BASE_URL+"/api/categories/delete";
export const APICategoriesPrint = BASE_URL + "/api/categories/print";
export const APICategoriesExportExcel = BASE_URL + "/api/categories/export-excel";
export const APICategoriesExportPDF = BASE_URL + "/api/categories/export-pdf";


// Products
export const APIProductsList = BASE_URL+"/api/products/list";
export const APIProductsStats = BASE_URL + "/api/products/stats";
export const APIProductsStore = BASE_URL+"/api/products/store";
export const APIProductsUpdate = BASE_URL+"/api/products/update";
export const APIProductsDelete = BASE_URL+"/api/products/delete";
export const APIProductsUpdateStock = BASE_URL + "/api/products/update-stock";
export const APIProductsPrint = BASE_URL + "/api/products/print";
export const APIProductsExportExcel = BASE_URL + "/api/products/export-excel";
export const APIProductsExportPDF = BASE_URL + "/api/products/export-pdf";

// Supplier
export const APISupplierList = BASE_URL+"/api/supplier/list";
export const APISupplierStats = BASE_URL + "/api/supplier/stats";
export const APISupplierStore = BASE_URL+"/api/supplier/store";
export const APISupplierUpdate = BASE_URL+"/api/supplier/update";
export const APISupplierDelete = BASE_URL+"/api/supplier/delete";
export const APISupplierPrint = BASE_URL + "/api/supplier/print";
export const APISupplierExportExcel = BASE_URL + "/api/supplier/export-excel";
export const APISupplierExportPDF = BASE_URL + "/api/supplier/export-pdf";


// Units
export const APIUnitList = BASE_URL + "/api/unit/list";
export const APIUnitName = BASE_URL + "/api/unit/names";
export const APIUnitStats = BASE_URL + "/api/unit/stats";
export const APIUnitStore = BASE_URL + "/api/unit/store";
export const APIUnitUpdate = BASE_URL + "/api/unit/update";
export const APIUnitDelete = BASE_URL + "/api/unit/delete";
export const APIUnitPrint = BASE_URL + "/api/unit/print";
export const APIUnitExportExcel = BASE_URL + "/api/unit/export-excel";
export const APIUnitExportPDF = BASE_URL + "/api/unit/export-pdf";
// Customer
export const APICustomerList = BASE_URL+"/api/customer/list";
export const APICustomerStore = BASE_URL+"/api/customer/store";
export const APICustomerStats = BASE_URL+"/api/customer/stats";
export const APICustomerUpdate = BASE_URL+"/api/customer/update";
export const APICustomerDelete = BASE_URL+"/api/customer/delete";
export const APICustomerPrint = BASE_URL + "/api/customer/print";
export const APICustomerExportExcel = BASE_URL + "/api/customer/export-excel";
export const APICustomerExportPDF = BASE_URL + "/api/customer/export-pdf";

// Expense
export const APIExpenseList = BASE_URL+"/api/expense/list";
export const APIExpenseStore = BASE_URL+"/api/expense/store";
export const APIExpenseUpdate = BASE_URL+"/api/expense/update";
export const APIExpenseDelete = BASE_URL+"/api/expense/delete";
export const APIExpenseStats =  BASE_URL+"/api/expense/stats";
export const APIExpensePrint = BASE_URL + "/api/expense/print";
export const APIExpenseExportExcel = BASE_URL + "/api/expense/export-excel";
export const APIExpenseExportPDF = BASE_URL + "/api/expense/export-pdf";

// Inventory
export const APIInventoryStats = BASE_URL + "/api/inventory/stats";
export const APIInventoryUpdate = BASE_URL + "/api/inventory/update";
export const APIInventoryHistory = BASE_URL + "/api/inventory/history";
export const APIInventoryLowStock = BASE_URL + "/api/inventory/low-stock";
export const APIInventoryPrint = BASE_URL + "/api/inventory/print";
export const APIInventoryExportExcel = BASE_URL + "/api/inventory/export-excel";
export const APIInventoryExportPDF = BASE_URL + "/api/inventory/export-pdf";
export const APIInventoryPrintHistory =  BASE_URL + "/api/inventory/print-history";


// Orders
export const APIOrdersStore = BASE_URL+"/api/orders/store";
export const APIOrdersList = BASE_URL+"/api/orders/list";
export const APIOrdersStats = BASE_URL + "/api/orders/stats";
export const APIOrdersLoans = BASE_URL+"/api/orders/loans";
export const APIOrdersDelete =  BASE_URL+"/api/orders/delete";
export const APIOrdersLoanStat = BASE_URL+"/api/orders/loans/stats";
export const APIOrdersPrint = BASE_URL + "/api/orders/print";
export const APIOrdersExportExcel = BASE_URL + "/api/orders/export-excel";
export const APIOrdersExportPDF = BASE_URL + "/api/orders/export-pdf";
export const APIOrdersUpdateStatus = BASE_URL + "/api/orders/update-status";


// Customer Loan Payments
export const APICustomerLoanPaymentsList = BASE_URL + "/api/customer-loans/payments/list";
export const APICustomerLoanPayments = BASE_URL + "/api/customer-loans/payments/order";
export const APICustomerLoanPaymentsStats = BASE_URL + "/api/customer-loans/payments/stats";
export const APICustomerLoanPaymentsPrint = BASE_URL + "/api/customer-loans/payments/print";
export const APICustomerLoanPaymentDelete = BASE_URL + "/api/customer-loans/payments/delete";
export const APICustomerLoanPaymentUpdate = BASE_URL + "/api/customer-loans/payments/update";
export const APICustomerLoanPaymentsExportExcel = BASE_URL + "/api/customer-loans/payments/export-excel";
export const APICustomerLoanPaymentsExportPDF = BASE_URL + "/api/customer-loans/payments/export-pdf";
export const APICustomerLoanAddPayment = BASE_URL + "/api/customer-loans/payments/add-payment";
// Customer Loan Orders
export const APICustomerLoansPrint = BASE_URL + "/api/customer-loans/orders/print";
export const APICustomerLoansExportExcel = BASE_URL + "/api/customer-loans/orders/export-excel";
export const APICustomerLoansExportPDF = BASE_URL + "/api/customer-loans/orders/export-pdf";



//Store Loans
export const APIStoreLoansList = BASE_URL+"/api/store-loans/list";
export const APIStoreLoansStore = BASE_URL+"/api/store-loans/store";
export const APIStoreLoansUpdate = BASE_URL+"/api/store-loans/update";
export const APIStoreLoansDelete = BASE_URL+"/api/store-loans/delete";
export const APIStoreLoansStats = BASE_URL+"/api/store-loans/stats";
export const APIStoreLoansPrint = BASE_URL + "/api/store-loans/print";
export const APIStoreLoansExportExcel = BASE_URL + "/api/store-loans/export-excel";
export const APIStoreLoansExportPDF = BASE_URL + "/api/store-loans/export-pdf";
export const APILoanAddHistory = BASE_URL + "/api/store-loans/history";

//  Store Loan Payments
export const APIStoreLoanPaymentsList = BASE_URL + "/api/store-loans-payments/list";
export const APIStoreLoanPaymentsListByLoan = BASE_URL+"/api/store-loans-payments/loan";
export const APIStoreLoanPaymentsStore = BASE_URL+"/api/store-loans-payments/store";
export const APIStoreLoanPaymentDelete = BASE_URL + "/api/store-loans-payments/delete";
export const APIStoreLoanPaymentUpdate = BASE_URL + "/api/store-loans-payments/update";
export const APIStoreLoanPaymentsStats = BASE_URL + "/api/store-loans-payments/stats";
export const APIStoreLoanPaymentsPrint = BASE_URL + "/api/store-loans-payments/print";
export const APIStoreLoanPaymentsExportExcel = BASE_URL + "/api/store-loans-payments/export-excel";
export const APIStoreLoanPaymentsExportPDF = BASE_URL + "/api/store-loans-payments/export-pdf";



// Company
export const APICompanyList = BASE_URL + "/api/company/list";
export const APICompanyStats = BASE_URL + "/api/company/stats";
export const APICompanyStore = BASE_URL + "/api/company/store";
export const APICompanyShow = BASE_URL + "/api/company/show/";
export const APICompanyUpdate = BASE_URL + "/api/company/update";
export const APICompanyDelete = BASE_URL + "/api/company/delete";
export const APICompanyNames = BASE_URL + "/api/company/names";
export const APICompanyConfig = BASE_URL + "/api/company/config";

// Database Management
export const APIMigrate = BASE_URL + "/api/migrate";
export const APIConfigCache = BASE_URL + "/api/config-cache";
export const APIClearCache = BASE_URL + "/api/clear-cache";
export const APIViewClear = BASE_URL + "/api/view-clear";
export const APIRouteCache = BASE_URL + "/api/route-cache";
export const APIClearAll = BASE_URL + "/api/clear-all";

// Permissions
export const APIPermissionList = BASE_URL + "/api/permission/list";
export const APIPermissionStats = BASE_URL + "/api/permission/stats";
export const APIPermissionStore = BASE_URL + "/api/permission/store";
export const APIPermissionUpdate = BASE_URL + "/api/permission/update";
export const APIPermissionDelete = BASE_URL + "/api/permission/delete";

// Settings Branche
export const APIBranchList = BASE_URL+"/api/branche/list";
export const APIBranchStats = BASE_URL + "/api/branche/stats";
export const APIBranchNames = BASE_URL+"/api/branche/names";
export const APIBranchStore = BASE_URL+"/api/branche/store";
export const APIBranchUpdate = BASE_URL+"/api/branche/update";
export const APIBranchDelete = BASE_URL+"/api/branche/delete";
export const APIBranchNamesFilter = BASE_URL+"/api/branche/names";